module.exports = "img/flags/LA.2856a6d.png";